export const portalVersion = "5.6"; 
